import { render, staticRenderFns } from "./chat-actions-menu.vue?vue&type=template&id=2736fd00&"
import script from "./chat-actions-menu.vue?vue&type=script&lang=js&"
export * from "./chat-actions-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2736fd00')) {
      api.createRecord('2736fd00', component.options)
    } else {
      api.reload('2736fd00', component.options)
    }
    module.hot.accept("./chat-actions-menu.vue?vue&type=template&id=2736fd00&", function () {
      api.rerender('2736fd00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/atendimento/components/chat-actions-menu/chat-actions-menu.vue"
export default component.exports